import Contrat, { ContratStatuts } from '@/generated/classes/Contrat';
import { storeContact } from '@/generated/stores';

export default class ContratExtend  extends Contrat {
  
  constructor() {
    super();
  }

  public static getTitle (contrat: Contrat): string {
    let interNom = '';
    if (contrat.emploiNom) {
      interNom = contrat.emploiNom;
    }
    if (contrat.salarieId > 0) {
      const contact = storeContact.getContact(contrat.salarieId);
      interNom = contact.prenom + ' ' + contact.nom + ' (' + interNom + ')';
    }
    return interNom;
  }

  public static getSubtitle (contrat: Contrat): string {
    let period = ''
    if (contrat.dateDebut) {
      if (contrat.dateFin && contrat.dateFin.toString() != contrat.dateDebut.toString()) {
        period = 'Du ' + contrat.dateDebut.toString();
      } else {
        period = 'Le ' + contrat.dateDebut.toString();
      }
    }
    if (contrat.dateFin && contrat.dateFin.toString() != contrat.dateDebut.toString()) {
      period = period + ' au ' + contrat.dateFin.toString();
    }
    return period;
  }

  public static getInfo (contrat: Contrat): string {
    let status = '';
    if (contrat.statut == ContratStatuts.APPROUVED && contrat.approvedAt) {
      status = 'Accepté le ' + contrat.approvedAt.toString();
    } else if (contrat.statut == ContratStatuts.SUBMITTED && contrat.submittedAt) {
      status = 'Soumis le ' + contrat.submittedAt.toString();
    } else if (contrat.statut == ContratStatuts.COMMENTED && contrat.commentedAt) {
      status = 'Commenté le ' + contrat.commentedAt.toString();
    } else if (contrat.statut == ContratStatuts.SIGNED && contrat.signedAt) {
      status = 'Signé le ' + contrat.signedAt.toString();
    } else if (contrat.statut == ContratStatuts.CHECKED) {
      status = 'Signé hors CI';
    } else {
      status = 'Brouillon'
    }
    return status;
  }

  public static getData (contrat: Contrat): string[] {
    const res: string[] = [];
    res.push(ContratExtend.getTitle(contrat));
    res.push(ContratExtend.getSubtitle(contrat));
    res.push(ContratExtend.getInfo(contrat));
    res.push("100");
    return res;
  }

  // eslint-disable-next-line
  public static getPicto (contrat: Contrat): string {
    return 'ProjetContrat';
  }

  private static getPeriod (contrat: Contrat): string {
    let period = ''
    if (contrat.dateDebut) {
      if (contrat.dateFin && contrat.dateFin.toString() != contrat.dateDebut.toString()) {
        period = 'Du ' + contrat.dateDebut.toString();
      } else {
        period = 'Le ' + contrat.dateDebut.toString();
      }
    }
    if (contrat.dateFin && contrat.dateFin.toString() != contrat.dateDebut.toString()) {
      period = period + ' au ' + contrat.dateFin.toString();
    }
    return period;
  }

  private static getStatus (contrat: Contrat): string {
    let status = '';
    if (contrat.statut == ContratStatuts.APPROUVED && contrat.approvedAt) {
      status = 'Accepté le ' + contrat.approvedAt.toString();
    } else if (contrat.statut == ContratStatuts.SUBMITTED && contrat.submittedAt) {
      status = 'Soumis le ' + contrat.submittedAt.toString();
    } else if (contrat.statut == ContratStatuts.COMMENTED && contrat.commentedAt) {
      status = 'Commenté le ' + contrat.commentedAt.toString();
    } else if (contrat.statut == ContratStatuts.SIGNED && contrat.signedAt) {
      status = 'Signé le ' + contrat.signedAt.toString();
    } else if (contrat.statut == ContratStatuts.CHECKED) {
      status = 'Signé hors CI';
    } else {
      status = 'Brouillon'
    }
    return status;
  }
}
